module.exports = __webpack_public_path__ + "static/avi_text.f44ba5f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logos/avi_text.svg
// module id = 745
// module chunks = 114276838955818